module.exports = __webpack_public_path__ + "img/title.1ac0f7ff.png";